import { EnvConfig } from '../../config/envconfig';
import { redirectIdentityServer } from './config';
import { removeUser } from '../utility/sessionStorage';

export const login = (config: EnvConfig) => {
    removeUser();

    // User is redirected to the correct application url depending on the after_redirect item in sessionStorage
    const afterRedirect = window.location.href
        .replace('/login', '')
        .substring(window.location.origin.length);
    if (!sessionStorage.getItem('after_redirect') && afterRedirect) {
        sessionStorage.setItem('after_redirect', afterRedirect);
    }

    sessionStorage.setItem(
        'redirect_uri',
        config.redirect_uri ?? `${window.location.origin}/light/`
    );
    return redirectIdentityServer(config, false);
};
